/**
 * Simple text normalization utilities with CJK language support
 */

import {
  containsCJKCharacters,
  normalizeCJKText,
  tokenizeTextWithCJK,
} from "./cjkTextUtils";

export function normalizeTextForComparison(text: string): string {
  if (!text) return "";

  return text.normalize("NFC").toLowerCase().trim().replace(/\s+/g, " ");
}

export function normalizeSentenceForComparison(sentence: string): string {
  if (!sentence) return "";

  // For CJK languages, use specialized normalization
  if (containsCJKCharacters(sentence)) {
    return normalizeCJKText(sentence);
  }

  return sentence
    .normalize("NFC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, "")
    .trim()
    .replace(/\s+/g, " ");
}

export function normalizeWordForComparison(word: string): string {
  if (!word) return "";

  return word
    .normalize("NFC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, "");
}

export function tokenizeText(text: string): string[] {
  return tokenizeTextWithCJK(text);
}
